import type { SimpleGit } from 'simple-git';

const EMPTY_TREE = '4b825dc642cb6eb9a060e54bf8d69288fbee4904';

export async function parentForCommitDiff(g: SimpleGit, sha: string): Promise<string> {
  try {
    return (await g.raw(['rev-parse', `${sha}^1`])).trim();
  } catch {
    try {
      return (await g.raw(['rev-parse', `${sha}^`])).trim();
    } catch {
      return EMPTY_TREE;
    }
  }
}
